import * as Tabs from '@radix-ui/react-tabs';
import { useState } from 'react';

import { CreateIndividual } from './individual/CreateIndividual';
import { FormData as IndividualFormData } from './individual/FormData';
import { CreateOrganization } from './organization/CreateOrganization';
import { FormData as OrgFormData } from './organization/FormData';
import { ProfileTypeToggleButton } from './ProfileTypeToggleButton';

type ProfileType = 'organization' | 'individual';

interface Props {
  className?: string;
  onComplete?(data: OrgFormData | IndividualFormData): void;
  initialFormData?: OrgFormData | IndividualFormData | null;
}

export function Create(props: Props) {
  // Determine initial profile type based on form data structure
  const getInitialType = (): ProfileType => {
    if (props.initialFormData) {
      return 'publisherName' in props.initialFormData
        ? 'organization'
        : 'individual';
    }
    return 'organization';
  };

  const [type, setType] = useState<ProfileType>(getInitialType);

  return (
    <div className={props.className}>
      <div className="text-xl text-white font-semibold">Publisher Profile</div>
      <div className="text-sm text-neutral-400">
        Seeker needs to verify your information to comply with regulations.
      </div>
      <div className="mt-6">
        <div className="text-white font-bold text-sm mb-1">
          Are you an organization or individual?
        </div>
        <Tabs.Root
          value={type}
          onValueChange={(e) => setType(e as ProfileType)}
        >
          <Tabs.List className="grid grid-cols-2 gap-x-4 h-10">
            <ProfileTypeToggleButton value="organization">
              Organization
            </ProfileTypeToggleButton>
            <ProfileTypeToggleButton value="individual">
              Individual
            </ProfileTypeToggleButton>
          </Tabs.List>
          <div className="mt-10">
            <Tabs.Content value="organization">
              <CreateOrganization
                onComplete={props.onComplete}
                initialFormData={
                  props.initialFormData &&
                  'publisherName' in props.initialFormData
                    ? props.initialFormData
                    : undefined
                }
              />
            </Tabs.Content>
            <Tabs.Content value="individual">
              <CreateIndividual
                onComplete={props.onComplete}
                initialFormData={
                  props.initialFormData && 'name' in props.initialFormData
                    ? props.initialFormData
                    : undefined
                }
              />
            </Tabs.Content>
          </div>
        </Tabs.Root>
      </div>
    </div>
  );
}
